import { DoctorSimple } from '@dreryk/egabinet-personnel-frontend-api';
import { PatientGroup } from '@dreryk/egabinet-patient-frontend-api';

import { useTranslate } from '@dreryk/react-common';

import { appointmentsTranslationKeys } from '../../../translations';
import { useAppointmentsFiltersContext } from '../AppointmentFilter.context';

import { useAppointmentsFiltersMeta } from './AppointmentsFilterChips.hooks';
import {
   APPOINTMENTS_FILTER_CHIPS_LABEL_CLASS_NAME,
   StyledAppointmentsFilterChips,
} from './AppointmentsFilterChips.styled';
import { DateChipFilter } from './DateChipFilter';
import { DoctorsChipFilter } from './DoctorsChipFilter';
import { PatientChipFilter } from './PatientChipFilter';
import { VisitAndAppointmentStatusChipFilter } from './VisitAndAppointmentStatusChipFilter';
import { VisitEncounterModeChipFilter } from './VisitEncounterModeChipFilter';
import { AppointmentConfirmationStatusChipFilter } from './AppointmentConfirmationStatusChipFilter/AppointmentConfirmationStatusChipFilter';
import { PatientPresenceChipFilter } from './PatientPresenceChipFilter/PatientPresenceChipFilter';
import { PatientGroupsFilter } from './PatientGroupsFilter';

type AppointmentsFilterChipsProps = {
   readonly doctors: DoctorSimple[];
   readonly doctorsFilterAvailable: boolean;
   readonly patientGroups: PatientGroup[];
};

export const AppointmentsFilterChips = (props: AppointmentsFilterChipsProps): JSX.Element => {
   const translate = useTranslate();
   const meta = useAppointmentsFiltersMeta();

   const { getFilter } = useAppointmentsFiltersContext();

   const practitionerIds = getFilter('practitioner');

   return (
      <StyledAppointmentsFilterChips data-testid={'appointments-filters'}>
         <span className={APPOINTMENTS_FILTER_CHIPS_LABEL_CLASS_NAME}>
            {`${translate(appointmentsTranslationKeys.filters.selectedFilters)}:`}
         </span>
         <PatientChipFilter label={meta.value?.patient} />
         <DateChipFilter />
         {props.doctorsFilterAvailable && practitionerIds?.length ? (
            <DoctorsChipFilter practitionerIds={practitionerIds} healthcareProviderDoctors={props.doctors} />
         ) : null}
         <VisitAndAppointmentStatusChipFilter />
         <VisitEncounterModeChipFilter />
         <AppointmentConfirmationStatusChipFilter />
         <PatientPresenceChipFilter />
         <PatientGroupsFilter patientGroups={props.patientGroups} />
      </StyledAppointmentsFilterChips>
   );
};
